// extracted by mini-css-extract-plugin
export default {"checkboxDummy":"HeaderRow_checkboxDummy__ucn60","placeHolderShimmer":"HeaderRow_placeHolderShimmer__9Aq64"};